class MoonSortDropdown extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.onBodyClick = this.onBodyClick.bind(this);
    this.onFormInput = this.onFormInput.bind(this);

    this.details.addEventListener('toggle', (event) => {
      if (this.details.open) {
        document.body.addEventListener('click', this.onBodyClick);
      } else {
        document.body.removeEventListener('click', this.onBodyClick);
      }
    });

    // Close when an option is selected (input changed)
    this.addEventListener('input', this.onFormInput);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  onFormInput(event) {
    if (event.target.type === 'radio') {
       // Update label text to match selected
       const label = this.querySelector(`label[for="${event.target.id}"]`);
       if(label) {
          const summaryText = this.querySelector('.moon-sort-label');
          if(summaryText) summaryText.textContent = label.textContent.trim();
       }
       this.close();
    }
  }

  close() {
    this.details.removeAttribute('open');
  }
}

customElements.define('moon-sort-dropdown', MoonSortDropdown);
